import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="group-photos-toggle"
export default class extends Controller {
  static targets = ["groupingSection", "toggle"]

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.updateVisibility()
  }

  updateVisibility() {
    const isGrouping = this.toggleTarget.checked
    
    this.groupingSectionTargets.forEach(section => {
      if (isGrouping) {
        section.classList.remove("hidden")
      } else {
        section.classList.add("hidden")
      }
    })
  }
}

